import React, { memo } from "react";

import { Button, Card, CardActions, CardContent, CardHeader, Chip, Stack } from '@material-ui/core';
import { UserReport } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import timeAgo from "../../utils/timeAgo";
import { PrimaryProfilePhoto, ProfileAvatar } from "../../components/UserPhoto/UserPhoto";

import ValueWithLabel from "../../components/ValueWithLabel";
import { areEqual } from "react-window";
import { Box, styled } from "@material-ui/system";
import { Link } from "@reach/router";
import { actions } from '../../services/reportedUsers';
import { useDialog } from "../../components/DialogProvider";
import { LoadingButton } from "@material-ui/lab";



const UserStatus = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '5px 10px',
  borderBottomLeftRadius: 10,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: '#fff',
})

interface Props {
  data: UserReport;
}

const ReportedUserItem: React.FC<Props> = ({ data }) => {
  const dispatch = useDispatch();
  const dialog = useDialog();
  const users = useSelector((state: RootState) => state.users.users);
  const state = useSelector((state: RootState) => state.reportedUsers);

  const authorName = users[ data.fromUserId ]?.firstName ?? '';
  const user = users[ data.userId ];

  const reportTime = timeAgo(data.createTime.toDate());



  return (
    <Card variant="outlined">
      <CardHeader
        avatar={
          <ProfileAvatar userId={data.fromUserId} size={40} />
        }
        title={authorName}
        subheader={reportTime}
        action={
          <Chip color={data.status === 'pending' ? 'warning' : 'success'} label={data.status} />

        }
      />
      <Box sx={{ position: 'relative' }}>
        <PrimaryProfilePhoto width={280} userId={data.userId} height={293} />
        {
          user?.status ? <UserStatus>
            {user.status}
          </UserStatus> : null
        }

      </Box>
      <CardContent>
        <ValueWithLabel
          label="Reason"
          value={data.reason}
        />
      </CardContent>
      <CardActions>
        <Stack direction="row" justifyContent="space-evenly" sx={{ flex: 1 }}>
          <LoadingButton
            size="small"
            loading={Boolean(state.pendingResolve[data.id])}
            onClick={() => {
              dispatch(actions.markAsResolved(data.id));
            }}
            disabled={data.status === 'resolved'}
          >
            Resolve
          </LoadingButton>
          <LoadingButton
            size="small"
            loading={Boolean(state.pendingDisable[data.id])}
            onClick={() => {
              dialog.confirm({
                title: `Are you sure you want to disable ${user?.firstName}?`,
                onConfirm: () => {
                  dispatch(actions.disableUser(data.id, data.userId));
                }
              });
            }}
            disabled={user?.status !== 'active'}
          >
            Disable
          </LoadingButton>
          {
            data.chatId ? <Button size="small" component={Link} to={`/chats/${data.chatId}`}>View Chat</Button> : null
          }

        </Stack>
      </CardActions>
    </Card>
  )
};

export default memo(ReportedUserItem, areEqual);
// export default ReportedUserItem;